export const HEADER_NAV = [
  {
    title: 'tickets',
    href_en: '/',
    href_ar: '/',
  },
  {
    title: 'store',
    href_en: 'https://shop.ittihadclub.sa/en',
    href_ar: 'https://shop.ittihadclub.sa',
    external: true,
  },
];
